<template>
  <div>
    <b-overlay
      variant="white"
      :show="showLoading"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <b-card no-body>
        <b-card-body>
          <b-row>
            <b-col md="4" class="mb-md-0 mr-5 d-flex align-items-center ">
              <b-button variant="gradient-danger" @click="back">
                <feather-icon icon="ArrowLeftIcon" class="mr-50" />
                <span class="align-middle">Atras</span>
              </b-button>
            </b-col>
            <b-col md="2" class="mb-md-0 ">
            <label>Rol Actual</label>
            <b-form-input :value="roleName" readonly />
            </b-col>
            <b-col class="d-flex align-items-center justify-content-end">
              <b-button variant="primary" @click="saveChanges">
                <span class="text-nowrap"> Guardar </span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <b-card no-body class="mb-0">
        <b-table
          :items="menus"
          :fields="fields"
          responsive="sm"
          bordered
          caption-top
        >
          <template #cell(name)="data">
            <span v-if="!data.item.menuParentId">
              <b>{{ data.item.name }}</b>
            </span>
            <span v-else> &nbsp;&nbsp;&nbsp;&nbsp;{{ data.item.name }} </span>
          </template>
          <template #cell(hasAccess)="data">
            <b-form-checkbox
              v-if="!data.item.hasChild"
              v-model="data.item.hasAccess"
              @change="onChangeAccess(data.item)"
            ></b-form-checkbox>
          </template>
          <template #cell(canAdd)="data">
            <b-form-checkbox
              v-if="!data.item.hasChild"
              :disabled="!data.item.hasAccess"
              v-model="data.item.canAdd"
            ></b-form-checkbox>
          </template>
          <template #cell(canEdit)="data">
            <b-form-checkbox
              v-if="!data.item.hasChild"
              :disabled="!data.item.hasAccess"
              v-model="data.item.canEdit"
            ></b-form-checkbox>
          </template>
          <template #cell(canDelete)="data">
            <b-form-checkbox
              v-if="!data.item.hasChild"
              :disabled="!data.item.hasAccess"
              v-model="data.item.canDelete"
            ></b-form-checkbox>
          </template>
        </b-table>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import RolesService from "@/services/RolesService";
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  data() {
    return {
      menus: [],
      showLoading: false,
      fields: [
        { key: "name", label: "Menú" },
        { key: "hasAccess", label: "Acceso", sortable: false },
        { key: "canAdd", label: "Agregar", sortable: false },
        { key: "canEdit", label: "Editar", sortable: false },
        { key: "canDelete", label: "Eliminar", sortable: false },
      ],
      role_id: this.$route.params.id,
      roleName: '',
    };
  },
  mounted() {
    this.getData();
    this.getRoleName();
  },
  methods: {
    async getData() {
      this.menus = [];
      this.showLoading = true;

      const resp = await RolesService.getPermission(
        this.$route.params.id,
        this.$store
      );
      console.log("Respuesta del servicio:", resp);

      if (resp.data) {
        this.menus = this.flattenMenus(resp.data);
      }

      this.showLoading = false;
    },
    onChangeAccess(menu) {
      if (!menu.hasAccess) {
        menu.canAdd = false;
        menu.canEdit = false;
        menu.canDelete = false;
      }
    },
    back() {
      this.$router.push({ name: "roles-list" });
    },
    flattenMenus(menus) {
      const flatMenus = [];
      menus.forEach((menu) => {
        menu.canAdd = menu.canAdd === 1;
        menu.canEdit = menu.canEdit === 1;
        menu.canDelete = menu.canDelete === 1;

        flatMenus.push(menu);

        if (menu.children && menu.children.length > 0) {
          menu.children.forEach((child) => {
            child.canAdd = child.canAdd === 1;
            child.canEdit = child.canEdit === 1;
            child.canDelete = child.canDelete === 1;

            flatMenus.push(child);
          });
        }
      });
      return flatMenus;
    },
    async saveChanges() {
      const childIds = this.menus
        .filter((menu) => menu.children && menu.children.length > 0)
        .flatMap((menu) => menu.children.map((child) => child.id));

      const filteredMenus = this.menus
        .filter((menu) => !childIds.includes(menu.id))
        .map((menu) => {
          return {
            id: menu.id,
            name: menu.name,
            hasAccess: menu.hasAccess,
            canAdd: menu.canAdd,
            canEdit: menu.canEdit,
            canDelete: menu.canDelete,
            hasChild: menu.children && menu.children.length > 0 ? 1 : 0,
            children: menu.children
              ? menu.children
                  .filter((child) => child.hasAccess)
                  .map((child) => ({
                    id: child.id,
                    name: child.name,
                    hasAccess: child.hasAccess,
                    canAdd: child.canAdd,
                    canEdit: child.canEdit,
                    canDelete: child.canDelete,
                    hasChild: 0,
                  }))
              : [],
          };
        });

      const rolePermissions = {
        roleId: this.role_id,
        menus: filteredMenus,
      };

      console.log(
        "Payload enviado al backend:",
        JSON.stringify(rolePermissions, null, 2)
      );

      const resp = await RolesService.savePermission(
        rolePermissions,
        this.$store
      );
      if (resp.error) {
        console.error("Error al guardar permisos:", resp.message);
      } else {
        console.log("Permisos guardados con éxito:", resp.message);
        this.$router.push({ name: "roles-list" });
      }
    },

    async getRoleName() {
      const roleId = parseInt(this.$route.params.id);
      const roleResp = await RolesService.getRole(roleId, this.$store);
      if (roleResp && roleResp.data) {
        this.roleName = roleResp.data.name;
      }
    },
  },
};
</script>

<style>
.b-table {
  overflow: hidden;
}
</style>
